import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { AcceleratorPage } from '../components/pages/accelerator/AcceleratorPage';
import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'accelerators',
});

const accelerator = PageBlueprint.make({
  params: {
    path: '/accelerators',
    loader: async () => <AcceleratorPage />,
  },
});

export const acceleratorPlugin = createFrontendPlugin({
  pluginId: 'accelerator',
  extensions: [accelerator],
});
